import $ from 'jquery';
import _ from 'lodash';
import util from 'util/Util';
import constants from 'Constants.js';
import { View } from 'backbone';
import { Model } from 'backbone';
import Template from 'behaviors/properties/main/set-selection-items.ejs';
import selectFieldModalView from 'common-views/SelectFieldModalView.js';
import SelectItemModalView from 'common-views/SelectItemModalView.js';
import CountryList from 'CountryList.js';
import USStates from 'USStates.js';
import CAStates from 'CAStates.js';
import RestService from 'RestService.js';

const predefinedLists = [
    {
        label: 'Countries',
        items: CountryList.getCountryList()
    },
    {
        label: 'US States',
        items: USStates.getStatesList()
    },
    {
        label: 'Canada Provinces',
        items: CAStates.getProvincesList()
    }
];

class MainSetSelectionItemsView extends View {


    initialize( opts ) {
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.gridEl = constants.PROP_MAIN_TABLE;

        this.events = {
            "click .itemNew" : "itemNew",
            "click .itemRemove" : "itemRemove",
            "click .itemUp" : "itemUp",
            "click .itemDown" : "itemDown",
            "click .defaultLists" : "showDefaultList",
            "click .field-select" : "selectField"
        };

        const prop = this.model.get('Property');
        const captions = _.find(prop, function(obj) { return obj._id === 'captions' });
        const values = _.find(prop, function(obj) { return obj._id === 'values' });

        if(captions.Item && values.Item) {
            let gridData =[];
            if (Array.isArray(captions.Item)) {
                for (let i = 0; i < captions.Item.length; i++) {
                    let newRow = {value: '', caption: ''};
                    newRow.caption = captions.Item[i]._value;
                    newRow.value = values.Item[i]._value;
                    gridData[i] = newRow;
                }
            }
            else {
                let newRow = {caption: captions.Item._value, value: values.Item._value};
                gridData.push(newRow);
            }
            this.model.set('gridData', gridData, {silent:true});
        }
        return this;
    }

    resizeGrid(){
        let grid = $('.ui-jqgrid-btable');
        if (grid) {
            grid.each(function(index) {
                let gridId = $(this).attr('id');
                //  If there is no width on parent yet, set a minimum width of 300px
                let gridParentWidth = $('#gbox_' + gridId).parent().width()? $('#gbox_' + gridId).parent().width() : 300;
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }
    }

    renderSetSelectionItemsGrid(){
        let self = this;
        let itemsToRender = this.model.get('gridData');
        const tableItems = [];

        _.forEach(itemsToRender, (field, index) => {
            tableItems.push({id: index, caption: field['caption'], value: field['value']});
        })

        let gridObject = util.getGridObject(this, {
            height: 110,
            autowidth: true, 
            shrinkToFit: true,
            autoencode: true,
            data: tableItems,
            colModel: this.model.get('colModel'),
            colNames: this.model.get('colNames'),
            afterEditCell:function(rowId, cellName, value, iRow, iCol){
                self.afterEditCell(rowId, cellName, value, iRow, iCol);
            },
            onCellSelect:this.onCellSelect,
            onSelectRow:this.onSelectRow,
            beforeSelectRow: this.setRow.bind(self),
            afterSaveCell:this.saveCell.bind(self), 
            resizeStop: function(width, index) {
                let grid = $(self.gridEl);
                let columns = grid.jqGrid('getGridParam', 'colModel');
                let colWidth = columns.filter(c => !c.hidden).reduce((a, c) => a + c.width, 0);

                if ($("#gbox_propMainTable").width() < colWidth) {
                    grid.closest('.ui-jqgrid-bdiv')
                        .css('overflow', '')
                        .addClass('format-table-overflow-shown');
                }
            }
        });
        $(this.gridEl).jqGrid(gridObject);
    }

    saveCell(rowid, cellname, value){
        let gridData = this.model.get('gridData');
        gridData[rowid][cellname] = util.sanitizeHTML(value, true, gridData[rowid][cellname]);
        this.model.set('gridData', gridData, {silent: true});
        this.setProperties(gridData);
        util.saveGridScrollPos(this.model);
        this.model.trigger('change');
    }

    showDefaultList(){
        RestService.browseCustomList().then(customLists => {
            let items = predefinedLists;
            customLists.map(function(item, index){
                items.push({
                    customListId:item['@CustomListId'],
                    label:item['@Name']
                });
            });

            const alertVIew = new SelectItemModalView({model: new Model({items:items})});

            alertVIew.render().then(selectedItem => {
                if(selectedItem){
                    this.fetchListItems(selectedItem).then(listItems => {
                        this.model.set('gridData', listItems, {silent:true});
                        this.setProperties(listItems);
                        this.render();
                    });

                }
            });
        });
    }

    fetchListItems(list){
        return new Promise((resolve, reject) => {
            if(list.customListId){
                RestService.getCustomList(list.customListId).then((customList) => {
                    let parsedList = [];

                    if (Array.isArray(customList)) {
                        customList.map((item) => {
                            parsedList.push({
                                value: item['@value'],
                                caption: item['@caption']
                            })
                        });
                    } else {
                        parsedList.push({
                            value: customList['@value'],
                            caption: customList['@caption']
                        })
                    }


                    resolve(parsedList);
                });
            } else {
                resolve(list.items);
            }
        });
    }

    fillNewRow(grid,index,caption,value){
        $(grid).addRowData(index, {caption:caption, value:value});
    }

    itemRemove(){
        const rowid = this.model.get('rowid');
        let gridData = this.model.get('gridData');
        const deleteIndex = rowid === undefined ? gridData.length -1: rowid;
        gridData.splice(deleteIndex, 1);

        if (gridData.length < 5) {
           let newRow = {caption:'', value:''};
           gridData.push(newRow);
        }
        this.setProperties(gridData);
        this.model.set('gridData', gridData,{silent:true});
        this.model.trigger('change');
        this.render();
    }

    itemNew(){
        let gridData = this.model.get('gridData'),
            newRow = {caption:'', value:''};

        // look for empty rows
        let lastIndex= _.findLastIndex(gridData,(item)=>{
            return item.caption !=='' || item.value !==''
        });

        if (lastIndex < 0) {
            let index = 0;
            newRow.caption = 'Item ' + (index + 1);
            newRow.value = index + 1;
            $(this.gridEl).addRowData((index), newRow);
            gridData.push(newRow);
        }
        else {
            lastIndex=gridData.length;
            newRow.caption = 'Item ' + (lastIndex + 1) ;
            newRow.value = (lastIndex + 1) ;
            $(this.gridEl).addRowData(lastIndex, newRow);
            gridData.push(newRow);
        }
        this.setProperties(gridData);
        this.model.set('gridData', gridData,{silent:true});
        this.model.set('newRowAdded', true, constants.MODEL_SILENT);
        util.saveGridScrollPos(this.model);
        this.model.trigger('change');
        this.render();
    }

    itemUp(){
        let gridData = this.model.get('gridData');
        let rowId = parseInt(this.model.get('rowid'));
        let newRowId = rowId - 1;

        if (rowId > 0) {
            gridData[rowId] = gridData.splice((newRowId), 1, gridData[rowId])[0];
            this.model.set('rowid', newRowId,{silent:true});
            this.model.set('gridData', gridData,{silent:true});
            this.model.trigger('change');
            this.render();
        }
        this.setProperties(gridData);
        util.saveGridScrollPos(this.model);
    }

    itemDown(){
        let gridData = this.model.get('gridData');
        let rowId = parseInt(this.model.get('rowid'));
        let newRowId = rowId + 1;

        if (rowId < (gridData.length - 1)) {
            gridData[rowId] = gridData.splice(newRowId, 1, gridData[rowId])[0];
            this.model.set('rowid', newRowId,{silent:true});
            this.model.set('gridData', gridData,{silent:true});
            this.model.trigger('change');
            this.render();
        }
        this.setProperties(gridData);
    }

    setRow(rowid){
        this.model.set({
            rowid: rowid
        }, {silent: true});
    }

    onCellSelect(rowid, iCol, cellcontent,e){
        return;
    }

    onDoubleClickRow (){
        return;
    }

    onSelectRow(rowId, status,e){
        return;
    }

    afterEditCell(rowId, cellName, value, iRow, iCol) {
        let self = this;
        $("#" + iRow + "_" + cellName).bind('blur', function () {
          $(self.gridEl).saveCell(iRow, iCol);
        });
      }

    setProperties(gridData){
        if (!gridData || !this.model.get('Property')){
            return;
        }

        let lastIndex = _.findLastIndex(gridData,(item)=>{
            return item.caption !=='' || item.value !==''
        });

        let properties = this.model.get('Property');

        // Cleaning properties for adding new one
        properties[0].Item = [];
        properties[1].Item = [];

        const captions = _.find(properties, function(obj) { return obj._id === 'captions' });
        const values = _.find(properties, function(obj) { return obj._id === 'values' });

        for (let i = 0; i <= lastIndex; i++) {
             captions.Item.push({'_value':gridData[i].caption});
             values.Item.push({'_value':gridData[i].value});
        }
        this.model.set('Property', properties, {silent:true});
    }

    render(){
        const html = this.template( this.model.toJSON() );

        this.$el.html( html );
        this.renderSetSelectionItemsGrid();
        this.resizeGrid();
        util.setGridScrollPos(this.model);
        this.delegateEvents();
        return this;
    }
}

export default MainSetSelectionItemsView;
